import Vue from 'vue'
import './contact-form.vue'

export default (el) =>
  new Vue({
    el,
  })
